export default __webpack_public_path__ + "static/media/entrega.755ff3ca.mp4";